import Vue from 'vue'
import Router from 'vue-router'

//组件模块
import login from './router/login'
import register from './router/register'
import getBackPassword from './router/getBackPassword'

import backHome from './router/backHome'
import backCollectionTask from './router/backCollectionTask'
import backTenderingMessage from './router/backTenderingMessage'
import backAddBid from './router/backAddBid'
import backEditTenderingMessage from './router/backEditTenderingMessage'
import backTagManage from './router/backTagManage'
import backPriceManage from './router/backPriceManage'
import backOrderManage from './router/backOrderManage'
import backInvoiceTitle from './router/backInvoiceTitle'
import backInvoiceTitleEdit from './router/backInvoiceTitleEdit'
import backPrivilegeManage from './router/backPrivilegeManage'
import backHelpCenter from './router/backHelpCenter'
import backEditHelp from './router/backEditHelp'
import backMember from './router/backMember'
import subscribe from './router/subscribe'
import backAdminSet from './router/backAdminSet'
import errPage from './router/404'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      redirect: '/backHome/backStatistics/home',
    },
    {
      path: '/register',
      name: 'register',
      component: register,
      meta: {
        title: '注册',
        mobilePath: '/mainPackage/register/register'
      }
    },
    {
      path: '/getBackPassword',
      name: 'getBackPassword',
      component: getBackPassword,
      meta: {
        title: '找回密码',
        mobilePath: '/mainPackage/geBackPassword/geBackPassword'
      }

    },
    {
      path: '/login',
      name: 'login',
      component: login
    },
    {
      path: '/backHome',
      name: 'backHome',
      component: backHome,
      children: [
        // 采购量统计分析
        {
          path: '/backHome/backStatistics',
          name: 'backStatistics',
          component: () => import('./router/statistics/index'),
          redirect: '/backHome/backStatistics/home',
          children: [
            {
              path: 'home',
              name: 'statisticsHome',
              component: () => import('./router/statistics/home')
            },
            {
              path: 'detail',
              name: 'statisticsDetail',
              component: () => import('./router/statistics/detail')
            }
          ]
        },
        {
          path: '/backHome/industryData',
          name: 'IndustryData',
          component: () => import('./router/industryData/index'),
          redirect: '/backHome/industryData/home',
          children: [
            {
              path: 'home',
              name: 'IndustryDataHome',
              component: () => import('./router/industryData/home')
            },
            {
              path: 'articleRanking',
              name: 'ArticleRanking',
              component: () => import('./router/industryData/articleRanking')
            },
            {
              path: 'articleDetail',
              name: 'ArticleDetail',
              component: () => import('./router/industryData/articleDetail')
            },
            {
              path: 'industryDetail',
              name: 'IndustryDetail',
              component: () => import('./router/industryData/industryDetail')
            },
            {
              path: 'revokeImport',
              name: 'RevokeImport',
              component: () => import('./router/industryData/revokeImport')
            }
            // {
            //   path: 'detail',
            //   name: 'statisticsDetail',
            //   component: () => import('./router/industryData/detail')
            // }
          ]
        },
        {
          path: '/backHome/backCollectionTask',
          name: 'backCollectionTask',
          component: backCollectionTask
        },
        {
          path: '/backHome/backTenderingMessage',
          name: 'backTenderingMessage',
          component: backTenderingMessage
        },
        {
          path: '/backHome/backTagManage',
          name: 'backTagManage',
          component: backTagManage
        },
        {
          path: '/backHome/backPriceManage',
          name: 'backPriceManage',
          component: backPriceManage
        },
        {
          path: '/backHome/backOrderManage',
          name: 'backOrderManage',
          component: backOrderManage
        },
        {
          path: '/backHome/backInvoiceTitle',
          name: 'backInvoiceTitle',
          component: backInvoiceTitle
        },
        {
          path: '/backHome/backRoleManage',
          name: 'backRoleManage',
          component: backPrivilegeManage
        },
        {
          path: '/backHome/backHelpCenter',
          name: 'backHelpCenter',
          component: backHelpCenter
        },
        {
          path: '/backHome/backMember',
          name: 'backMember',
          component: backMember
        },
        {
          path: '/backHome/subscribe',
          name: 'subscribe',
          component: subscribe
        },
        {
          path: '/backHome/backAdminSet',
          name: 'backAdminSet',
          component: backAdminSet
        },
        {
          path: '/backHome/backMenuManage',
          name: 'backMenuManage',
          component: () => import('./router/backMenuSet/index.vue')
        },
        {
          path: '/backHome/backMenuManageTwo',
          name: 'backMenuManageTwo',
          component: () => import('./router/backMenuSet/menuTwo.vue')
        },
        {
          path: '/backHome/backMenuManageThree',
          name: 'backMenuManageThree',
          component: () => import('./router/backMenuSet/menuThree.vue')
        },
        {
          path: '/backHome/backScheduledConfig',
          name: 'backScheduledConfig',
          component: () => import('./router/taskManage/taskManage.vue')
        },
        /* 品目管理 start*/
        {
          path: '/backHome/namesAudit',
          name: 'namesAudit',
          component: () => import('./router/names/namesAudit/index.vue')
        },
        {
          path: '/backHome/namesAudit/namesAuditList',
          name: 'namesAuditList',
          component: () => import('./router/names/namesAudit/namesAuditList.vue')
        },
        {
          path: '/backHome/namesAudit/namesAuditListSubEdit',
          name: 'namesAuditListSubEdit',
          component: () => import('./router/names/namesAudit/namesAuditListSubEdit.vue')
        },

        {
          path: '/backHome/namesPerfect',
          name: 'namesPerfect',
          component: () => import('./router/names/namesPerfect/index.vue'),
        },
        {
          path: '/backHome/namesPerfect/namesPerfectList',
          name: 'namesPerfectList',
          component: () => import('./router/names/namesPerfect/namesPerfectList.vue')
        },
        {
          path: '/backHome/namesPerfect/namesPerfectListSubEdit',
          name: 'namesPerfectListSubEdit',
          component: () => import('./router/names/namesPerfect/namesPerfectListSubEdit.vue')
        },
        /* 品目管理 end*/
        /*标准库管理 start*/
        /*采购人库*/
        {
          path: '/backHome/standardPurchaserPool',
          name: 'standardPurchaserPool',
          component: () => import('./router/standard/standardPurchaserPool/index.vue')
        },
        /*代理机构库*/
        {
          path: '/backHome/standarAagency',
          name: 'standarAagency',
          component: () => import('./router/standard/standarAagency/index.vue')
        },
        /*供应商库库*/
        {
          path: '/backHome/standardVendor',
          name: 'standardVendor',
          component: () => import('./router/standard/standardVendor/index.vue')
        },
        /*标准库管理 end*/
        {
          path: '*',
          name: 'errPage',
          component: errPage
        }
      ]
    },
    {
      path: '/backEditTenderingMessage',
      name: 'backEditTenderingMessage',
      component: backEditTenderingMessage
    },
    {
      path: '/backAddBid',
      name: 'backAddBid',
      component: backAddBid
    },
    {
      path: '/backInvoiceTitleEdit',
      name: 'backInvoiceTitleEdit',
      component: backInvoiceTitleEdit
    },
    {
      path: '/backEditHelp',
      name: 'backEditHelp',
      component: backEditHelp
    },
    {
      path: '*',
      name: '404',
      component: errPage
    }
  ]
})